module.exports = __webpack_public_path__ + "fonts/LTCCaymanGoudyModern-Italic.c3b658682b7b0f7ca49b67443cd4f9b1.woff2";